import { useMemo, type CSSProperties } from 'react';
import { BioHeader } from './components/BioHeader';
import { BioLink } from './components/BioLink';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { SocialLinks } from './components/SocialLinks';
import { profile } from './data/profile';
import { services } from './data/services';
import { useSeo } from './hooks/useSeo';

export default function App() {
  const cssVariables = useMemo(
    () =>
      ({
        '--color-background': profile.colors.background,
        '--color-surface': profile.colors.surface,
        '--color-text': profile.colors.text,
        '--color-muted': profile.colors.muted,
        '--color-accent': profile.colors.accent,
        '--color-beam': profile.colors.beam,
        '--color-border': profile.colors.border
      }) as CSSProperties,
    []
  );

  useSeo(profile.seo);

  return (
    <main className="bio-shell" style={cssVariables}>
      <div className="bio-card" aria-label="Biolink da 2Players Marketing">
        <BioHeader profile={profile} />

        <section className="bio-links" aria-label="Links principais">
          {profile.links.map((link, index) => (
            <BioLink key={link.id} link={link} index={index} />
          ))}
        </section>

        <SocialLinks links={profile.socials} />
        <ContactForm form={profile.contactForm} services={services} />
        <Footer text={profile.footer} />
      </div>
    </main>
  );
}
